import { render, staticRenderFns } from "./HallOfFameFutures.vue?vue&type=template&id=fca83fd0&scoped=true"
import script from "./HallOfFameFutures.vue?vue&type=script&lang=js"
export * from "./HallOfFameFutures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca83fd0",
  null
  
)

export default component.exports